export default "__VITE_ASSET__s$vxp38Y__"